import React from "react";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";

const ICCheckbox = props => {
  const {className, style, ...checkboxProps} = props;
 return <FormControlLabel
   style={style}
    className={className}
    control={
      <Checkbox
        className="ic-checkbox"
        {...checkboxProps}
        checked={props.value || false}
      />
    }
    label={props.label}
    labelPlacement={props.labelPlacement || "end"}
  />
};

export default ICCheckbox;
